import WidgetEntity from '../WidgetEntity';
import * as Widgets from "@mm/constants/widgets";

export default class AttributeWidget extends WidgetEntity {
  static make(pageId, sortOrder) {
    return {
      ...super.make(pageId, Widgets.ATTRIBUTE, '', sortOrder),
      config: {
        variableId: null,
        value: '',
      },
    };
  }
}
